import {
    FileSearchIcon,
    FileTextIcon,
    // PencilLine,
    Trash,
    X,
} from "lucide-react";
import NoPreviewCard from "../card/no-preview-card";
import MedicationsTable from "../tables/medications-table";
// import RefillRequestTable from "../tables/refill-request-table";
// import RefillHistoryTable from "../tables/refill-history";
import { PatientMedicalPlan, PatientSessions, PatientSummaryData, UrgentPatientMedication } from "../../api/types";
import { Button } from "@workspace/web-ui/components/button";
import { useState } from "react";
import { usePrescriptionModalStore } from "../../store/prescription-modal-store";

// ✅ Add these component imports
import { MultiStepDialog } from "../../../../components/multi-step-dialog";
import { Input } from "@workspace/web-ui/components/input";
import {
    Select,
    SelectTrigger,
    SelectContent,
    SelectItem,
    SelectValue,
} from "@workspace/web-ui/components/select";
import { Textarea } from "@workspace/web-ui/components/textarea";
import {
    AlertDialog,
    AlertDialogContent,
    AlertDialogFooter,
    AlertDialogAction,
    AlertDialogCancel,
} from "@workspace/web-ui/components/alert-dialog";

// ✅ Add hook
import { usePrescription } from "../../hooks/use-prescription";
import { PrescriptionModal } from "../modals/prescription-modal";
import { VITAMIN_OPTIONS } from "~/features/dashboard/components/tasks/task-form";
import DosespotButton from "../../pages/dosespotModal";
import { FormattedEncounter } from "../../../encounters/types";
import { useSendActionNeededMutation } from "../../api/mutations";
import { toast } from "sonner";

interface MedicationProps {
    isLoading?: boolean;
    patient: PatientMedicalPlan | null;
    userId: string;
    medicationData?: {
        status: string;
        message: string;
        refill_requests: Array<any>;
        current_medications: Array<any>;
        medication_refill_history: Array<any>;
    };
    medicalPlanData?: any;
    patientData?: PatientSummaryData;
    encounter?: FormattedEncounter;
    selectedSession?: SessionType;
    urgentMedicationData?: UrgentPatientMedication;
    urgentCurrentMedicationData?: UrgentPatientMedication;
    urgentRequestsMedicationData?: UrgentPatientMedication;
    urgentHistoryMedicationData?: UrgentPatientMedication;
}

interface DosageOption {
    dosage: string;
    price: number;
}

type MedicationKey = "Compounded Semaglutide" | "Compounded Tirzepatide" | "Zepbound (Branded Tirzepatide)";
type SessionType = PatientSessions['sessions'][0];

const MedicationView = ({
    // patient,
    urgentMedicationData,
    // setOpenDeleteDialog,
}: {
    patient: PatientMedicalPlan | null;
    urgentMedicationData?: UrgentPatientMedication;
    setOpenDeleteDialog: (open: boolean) => void;
}) => {
    return (
    <div className="mt-4">
        {urgentMedicationData?.data && urgentMedicationData.data.length > 0 ? (
            urgentMedicationData.data.map((med, idx) => (
                <div
                    key={med.PrescriptionId || idx}
                    className="w-full bg-[#EBF0FB] p-4 rounded-md flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4 relative mb-2"
                >
                    <div className="flex flex-col space-y-1 flex-1">
                        <div className="flex items-center gap-2 text-base font-medium text-[#1A202C]">
                            <span>{med.DisplayName}</span>
                            <span className="text-sm text-gray-600">•</span>
                            {/* <span className="text-[#1A202C] font-semibold">${med.pharmacy?.Price}</span> */}
                        </div>
                        <p className="text-sm text-gray-600">
                            Dosage: {med.Strength}
                        </p>
                        <p className="text-sm text-gray-600">
                            Duration: {med.DaysSupply}
                        </p>
                        {/* <p className="text-sm text-gray-600">Vitamin: {patient?.program_details.plan.vitamin?.name}</p> */}
                        {/* <p className="text-sm text-gray-600">
                            Instructions: Inject subcutaneously in the abdomen
                        </p> */}
                    </div>
                    {/* <div className="flex items-center gap-4 sm:justify-end w-full sm:w-auto">
                        <button
                            onClick={() => setOpenDeleteDialog(true)}
                            className="text-[#4272DD] text-sm hover:underline border-none outline-none flex items-center gap-1"
                        >
                            <Trash className="w-4 h-4" />
                            Delete
                        </button>
                    </div> */}
                </div>
            ))
        ) : (
            <div className="w-full bg-[#EBF0FB] p-4 rounded-md flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4 relative">
                <div className="text-sm text-gray-600 flex-1">No urgent care medication prescribed.</div>
            </div>
        )}
    </div>
    );
}
    

const NoMedicationView = ({
    medication,
    // urgentMedicationData,
    // vitamin,
    // medicationReviewed,
    // handleAddMedication,
    setOpenDeleteDialog,
}: {
    medication: string;
    vitamin: string;
    medicationReviewed: boolean;
    urgentMedicationData?: UrgentPatientMedication;
    handleAddMedication: () => void;
    setOpenDeleteDialog: (open: boolean) => void;
}) => (
    <div className="w-full flex flex-col sm:flex-row gap-4 bg-[#EBF0FB] p-4 rounded-[8px] mt-2">
        <div className="flex flex-col space-y-1 flex-1">
            {/* <p className="text-[#464B55] text-xs">Selected Medication:</p> */}
            <p className="text-[#1A202C] text-sm font-medium">{medication || "--"}</p>
        </div>

        <div className="flex gap-2 w-full border sm:w-fit">
            {medication && (
                <Button
                    variant="outline"
                    className="text-[#4272DD] hover:text-[#4272DD] bg-transparent border-none shadow-none p-0 hover:bg-transparent"
                    onClick={() => setOpenDeleteDialog(true)}
                >
                    <Trash />
                    <p>Delete</p>
                </Button>
            )}
        </div>

    </div>
);


export const UrgentCareMedication = ({
    urgentMedicationData,
    urgentCurrentMedicationData,
    urgentRequestsMedicationData,
    // urgentHistoryMedicationData,
    // medicalPlanData,
    patient,
    userId,
    encounter,
    patientData,
    selectedSession
}: MedicationProps) => {    
    const refillRequestsData =
        urgentRequestsMedicationData?.data ?? [];
    console.log("refillRequestsData", refillRequestsData)

    const currentMedicationsData =
        urgentCurrentMedicationData?.data ?? [];

    // const refillHistoryData =
    //     urgentHistoryMedicationData?.data ?? [];

    const [reviewMode, setReviewMode] = useState(true);
    const [openReviewModal, setOpenReviewModal] = useState(false);
    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
    const [durationError, setDurationError] = useState("");

    const [medication, setMedication] = useState(
        patient?.program_details.plan.medication.name || ""
    );
    const [medicationReviewed, setMedicationReviewed] = useState(false);

    // ✅ Hook state
    const [newMedication, setNewMedication] = useState(medication);
    const [justification, setJustification] = useState("");
    const [dosage, setDosage] = useState("");
    const [price, setPrice] = useState("");
    const [duration, setDuration] = useState("");
    const [instructions, setInstructions] = useState("");
    const [refills, setRefills] = useState("");
    // Add vitamin state
    const [vitamin, setVitamin] = useState("");
    // const [isDosespotOpen, setDosespotOpen] = useState(false);

    const medicationOptions = [
        "Compounded Semaglutide",
        "Compounded Tirzepatide",
        "Zepbound (Branded Tirzepatide)",
    ];


    const { handleSubmit } = usePrescription(encounter?.encounterId || "");
    const { openPrescriptionModal, setOpenPrescriptionModal } =
        usePrescriptionModalStore();
    const { mutate: sendActionNeeded, isPending: sendActionpending } = useSendActionNeededMutation();

    const medicationPricing = {
        "Compounded Semaglutide": [
            { dosage: "0.25 mg", price: 199.99 },
            { dosage: "0.5 mg", price: 249.99 },
            { dosage: "0.75 mg", price: 299.99 },
            { dosage: "1 mg", price: 349.99 }
        ],
        "Compounded Tirzepatide": [
            { dosage: "2.5 mg", price: 249.99 },
            { dosage: "5 mg", price: 299.99 },
            { dosage: "7.5 mg", price: 399.99 },
            { dosage: "10 mg", price: 499.99 }
        ],
        "Zepbound (Branded Tirzepatide)": [
            { dosage: "2.5 mg", price: 349.99 },
            { dosage: "5 mg", price: 499.99 },
            { dosage: "7.5 mg", price: 599.99 },
            { dosage: "10 mg", price: 699.99 }
        ]
    };

    const getAvailableDosages = (medication: string): DosageOption[] => {
        return medicationPricing[medication as MedicationKey] || [];
    };

    const hasAppointmentTask = selectedSession?.encounter?.recommended_tasks.some(task => 
        task.type === "appointment_followup" && 
        task.status !== "completed" // Assuming you might have a status field
    );

    const urgentCareOnboarded = encounter?.patient?.urgent_care_onboarded ?? patientData?.urgent_care_onboarded ?? false;
    const identityVerified = encounter?.patient?.identity_verified ?? patientData?.identity_verified ?? false;

    const getPriceForDosage = (medication: string, dosage: string): string => {
        const options = medicationPricing[medication as MedicationKey] || [];
        const option = options.find(opt => opt.dosage === dosage);
        return option ? option.price.toString() : "";
    };

    // function formatFullDate(dateString: string): string | null {
    //     try {
    //         const date = new Date(dateString);
    //         if (isNaN(date.getTime())) return null;
    //         return date.toLocaleDateString("en-US", {
    //             year: "numeric",
    //             month: "long",
    //             day: "numeric",
    //         });
    //     } catch (error) {
    //         return null;
    //     }
    // }

    const handleAddMedication = () => {
        setOpenPrescriptionModal(true);
    };

    if (openPrescriptionModal) {
        return (
            <PrescriptionModal
                open={openPrescriptionModal}
                patientId={userId}
                onOpenChange={setOpenPrescriptionModal}
            />
        );
    }

    return (
        <div className="flex flex-col gap-4">
            <div className="rounded-lg border shadow w-full bg-white">
                {/* <div className="p-4 border-b flex items-center justify-between">
                    <h2 className="text-lg font-medium">Medication Plan</h2>
                    <Button
                        className="bg-[#4272DD] text-white px-4 py-2 rounded-md hover:bg-[#365DC9]"
                        onClick={handleAddMedication}
                    >
                        + Add medication
                    </Button>
                </div> */}
                <div className="p-4">
                    <div className="flex items-center justify-between">
                        <div>
                            <h3 className="font-medium">Medication Plan</h3>
                        </div>
                        <div>
                            {urgentCareOnboarded && identityVerified ? (
                                <DosespotButton
                                    userDosespotId={encounter?.patient.user_dosespot_id || patientData?.user_dosespot_id}
                                    sessionId={encounter?.session?.session_id || selectedSession?.session_id}
                                    encounterId={encounter?.encounterId || selectedSession?.encounter?.encounter_id}
                                    urgent_care_onboarded={true}
                                    disabled={hasAppointmentTask}
                                    onSuccess={() => {}}
                                />
                            ) : (
                                <Button
                                    className="button-primary !bg-[#4272DD] h-[44px] !text-white flex gap-2 items-center !shadow-none w-fit !border-none"
                                    onClick={async () => {
                                        try {
                                            const patientId = encounter?.patient.id || patientData?.userId || userId;
                                            if (patientId) {
                                                await sendActionNeeded({ patient_id: patientId });
                                                toast.success("Reminder sent to patient to complete verification.");
                                            }
                                        } catch (error) {
                                            toast.error("Failed to send reminder.");
                                        }
                                    }}
                                    disabled={sendActionpending}
                                >
                                    {sendActionpending && (
                                        <svg className="animate-spin h-4 w-4 mr-2 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
                                        </svg>
                                    )}
                                    Send a Reminder
                                </Button>
                            )}
                        </div>
                    </div>
                    {urgentMedicationData?.data && urgentMedicationData.data.length > 0 ? (
                        <MedicationView
                            patient={patient}
                            setOpenDeleteDialog={setOpenDeleteDialog}
                            urgentMedicationData={urgentMedicationData}
                        />
                    ) : (
                        <NoMedicationView
                            medication={medication}
                            vitamin={patient?.program_details?.plan?.vitamin?.name ?? ""}
                            medicationReviewed={medicationReviewed}
                            handleAddMedication={handleAddMedication}
                            setOpenDeleteDialog={setOpenDeleteDialog}
                            urgentMedicationData={urgentMedicationData}
                        />
                    )}

                </div>
                {patient?.medication_plan &&
                    patient.medication_plan.length > 0 &&
                    patient.medication_plan.map((plan, index) => (
                        <div className="p-4" key={index}>
                            <div className="w-full bg-[#EBF0FB] p-4 rounded-md flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4 relative">
                                <div className="flex flex-col space-y-1 flex-1">
                                    <div className="flex items-center gap-2 text-base font-medium text-[#1A202C]">
                                        <span>{plan.name}</span>
                                        <span className="text-sm text-gray-600">•</span>
                                        <span className="text-[#1A202C] font-semibold">
                                            ${plan.cost}
                                        </span>
                                    </div>
                                    {/* Add vitamin display if available */}
                                    {/* <p className="text-sm text-gray-600">
                                        Vitamin: {plan.vitamin}
                                    </p> */}
                                    <p className="text-sm text-gray-600">
                                        Dosage: {plan.dosage}
                                    </p>
                                    <p className="text-sm text-gray-600">
                                        Duration: {plan.duration}
                                    </p>
                                    <p className="text-sm text-gray-600">
                                        Vitamin: {plan?.vitamin?.name || '--'}
                                    </p>
                                    <p className="text-sm text-gray-600">
                                        Instructions: {plan.instructions}
                                    </p>
                                </div>
                                {plan.name && (
                                    <div className="flex items-center gap-4 sm:justify-end w-full sm:w-auto">
                                        <button
                                            onClick={() => setOpenDeleteDialog(true)}
                                            className="text-[#4272DD] text-sm hover:underline flex items-center gap-1"
                                        >
                                            <Trash className="w-4 h-4" />
                                            Delete
                                        </button>
                                    </div>
                                )}
                            </div>
                        </div>
                    ))}
            </div>

            {/* Current Medications */}
            {currentMedicationsData.length > 0 ? (
                <MedicationsTable
                    data={currentMedicationsData.map((medication) => ({
                        medication: medication.DisplayName,
                        price: "",
                        prescribed_date: medication.WrittenDate,
                        refills: medication.Refills,
                        status: medication.Status,
                    }))}
                    cardTitle={"Current Medications"}
                />
            ) : (
                <NoPreviewCard
                    Icon={FileTextIcon}
                    title={"Nothing Yet"}
                    description={"The Patient Currently Has no current medications."}
                    cardTitle={"Current Medications"}
                />
            )}

            {/* Medication Requests Table */}
            <div className="rounded-lg border shadow w-full bg-white mt-6">

                {refillRequestsData.length > 0 ? (
                    <div className="overflow-x-auto">
                        <table className="min-w-full text-sm text-left">
                            <thead className="bg-gray-50 border-b text-xs font-semibold text-gray-600">
                                <tr>
                                    <th className="px-4 py-3">Medication</th>
                                    <th className="px-4 py-3">Price</th>
                                    <th className="px-4 py-3">Requested Date</th>
                                    <th className="px-4 py-3">Status</th>
                                    <th className="px-4 py-3">Actions</th>
                                </tr>
                            </thead>
                            <tbody className="divide-y">
                                {refillRequestsData.map((request: any, index: number) => (
                                    <tr key={index} className="hover:bg-gray-50">
                                        <td className="px-4 py-3">{request.medication.name || request.medication_name}</td>
                                        <td className="px-4 py-3">
                                            {request.cost || request.price ? `$${(request.cost || request.price).toFixed(2)}` : '$--'}
                                        </td>
                                        <td className="px-4 py-3">{request.requested_date || request.request_datetime}</td>
                                        <td className="px-4 py-3">
                                            <span
                                                className={`px-2 py-1 rounded-full text-xs font-medium ${request.status === 'Pending' || request.refill_status === 'Pending'
                                                    ? 'bg-yellow-100 text-yellow-700'
                                                    : request.status === 'Processing' || request.refill_status === 'Processing'
                                                        ? 'bg-blue-100 text-blue-700'
                                                        : 'bg-gray-100 text-gray-700'
                                                    }`}
                                            >
                                                {request.status || request.refill_status}
                                            </span>
                                        </td>
                                        <td className="px-4 py-3">
                                            {request.status === 'Pending' ? (
                                                <Button
                                                    className="bg-[#4272DD] text-white px-4 py-1 text-sm"
                                                    onClick={() => {
                                                        setReviewMode(true);
                                                        setOpenReviewModal(true);
                                                    }}
                                                >
                                                    Review
                                                </Button>
                                            ) : (
                                                <Button
                                                    variant="outline"
                                                    className="text-gray-700 border border-gray-300 px-4 py-1 text-sm"
                                                >
                                                    View
                                                </Button>
                                            )}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                ) : (
                    <NoPreviewCard
                        Icon={FileSearchIcon}
                        title={"Nothing Yet"}
                        description={"The Patient Currently Has no active refill requests."}
                        cardTitle={"Refill Requests"}
                    />
                )}
            </div>



            {/* ✅ MultiStepDialog */}
            <MultiStepDialog
                open={openReviewModal}
                onOpenChange={setOpenReviewModal}
                initialData={{
                    medication: medication,
                    newMedication: newMedication,
                    reason: justification,
                    dosage: dosage,
                    price: price,
                    refills: refills,
                    duration: duration,
                    instructions: instructions,
                    vitamin: vitamin, // add vitamin to initialData
                }}
                steps={[
                    {
                        title: `${reviewMode ? "Review" : "Edit"} medication - ${patient?.patient_summary.full_name || "Patient"
                            }`,
                        content: (formData, setFormData) => (
                            <div className="space-y-4">
                                <div>
                                    <label className="block text-xs mb-1">
                                        Current Medication:
                                    </label>
                                    <div className="bg-gray-100 rounded px-3 py-2 text-sm">
                                        {formData.medication}
                                    </div>
                                </div>
                                <div>
                                    <label className="block text-xs mb-1">New Medication</label>
                                    <Select
                                        value={formData.newMedication}
                                        onValueChange={(val) =>
                                            setFormData((f) => ({ ...f, newMedication: val }))
                                        }
                                    >
                                        <SelectTrigger>
                                            <SelectValue placeholder="Select medication" />
                                        </SelectTrigger>
                                        <SelectContent>
                                            {medicationOptions.map((option) => (
                                                <SelectItem key={option} value={option}>
                                                    {option}
                                                </SelectItem>
                                            ))}
                                        </SelectContent>
                                    </Select>
                                </div>
                                {/* Vitamin field */}
                                {/* <div>
                                    <label className="block text-xs mb-1">Vitamin</label>
                                    <Input
                                        value={formData.vitamin}
                                        onChange={(e) =>
                                            setFormData((f) => ({ ...f, vitamin: e.target.value }))
                                        }
                                        placeholder="e.g. Vitamin B12"
                                    />
                                </div> */}
                                <div>
                                    <label className="block text-xs mb-1">
                                        Medical Justification:
                                    </label>
                                    <Textarea
                                        value={formData.reason}
                                        onChange={(e) =>
                                            setFormData((f) => ({ ...f, reason: e.target.value }))
                                        }
                                        placeholder="Enter medical reason for medication change"
                                        maxLength={200}
                                    />
                                    <div className="text-xs text-right">
                                        {formData.reason?.length || 0}/200
                                    </div>
                                </div>
                            </div>
                        ),
                        validate: (formData) =>
                            !!formData.newMedication && !!formData.reason,
                    },
                    {
                        title: `${reviewMode ? "Review" : "Edit"} medication - ${patient?.patient_summary.full_name || "Patient"}`,
                        content: (formData, setFormData) => (
                            <div className="space-y-4">
                                <div>
                                    <label className="block text-xs mb-1">Dosage</label>
                                    <Select
                                        value={formData.dosage}
                                        onValueChange={(selectedDosage) => {
                                            // Auto-populate price when dosage is selected
                                            const autoPrice = getPriceForDosage(formData.newMedication, selectedDosage);
                                            setFormData((f) => ({
                                                ...f,
                                                dosage: selectedDosage,
                                                price: autoPrice
                                            }));
                                        }}
                                    >
                                        <SelectTrigger>
                                            <SelectValue placeholder="Select dosage" />
                                        </SelectTrigger>
                                        <SelectContent>
                                            {getAvailableDosages(formData.newMedication).map((option) => (
                                                <SelectItem key={option.dosage} value={option.dosage}>
                                                    {option.dosage}
                                                </SelectItem>
                                            ))}
                                        </SelectContent>
                                    </Select>
                                </div>
                                <div className="flex gap-2">
                                    <div className="flex-1">
                                        <label className="block text-xs mb-1">Price</label>
                                        <Input
                                            value={formData.price}
                                            onChange={(e) =>
                                                setFormData((f) => ({ ...f, price: e.target.value }))
                                            }
                                            placeholder="$"
                                        />
                                    </div>
                                    <div className="flex-1">
                                        <label className="block text-xs mb-1">Duration</label>
                                        <div className="relative">
                                            <Input
                                                value={formData.duration}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    const isNumber = /^\d*$/.test(value);
                                                    setFormData((f) => ({ ...f, duration: value }));
                                                    setDurationError(isNumber ? '' : 'Duration must be a number');
                                                }}
                                                placeholder="e.g. 30"
                                                type="text"
                                                inputMode="numeric"
                                                className={`pr-12 ${durationError ? 'border-red-500 focus-visible:ring-red-500' : ''}`}
                                            />
                                            <span className="absolute top-1/2 right-4 -translate-y-1/2 text-sm text-gray-500">Days</span>
                                        </div>
                                        {durationError && <p className="text-xs text-red-500 mt-1">{durationError}</p>}
                                    </div>
                                </div>
                                {formData.newMedication !== "Zepbound (Branded Tirzepatide)" && (
                                    <div>
                                        <label className="block text-xs mb-1">Vitamin</label>
                                        <Select
                                            value={formData.vitamin}
                                            onValueChange={(val) =>
                                                setFormData((f) => ({ ...f, vitamin: val }))
                                            }
                                        >
                                            <SelectTrigger>
                                                <SelectValue placeholder="Select vitamin" />
                                            </SelectTrigger>
                                            <SelectContent>
                                                {VITAMIN_OPTIONS.map((vitamin) => (
                                                    <SelectItem key={vitamin} value={vitamin}>
                                                        {vitamin}
                                                    </SelectItem>
                                                ))}
                                            </SelectContent>
                                        </Select>
                                    </div>
                                )}

                                <div>
                                    <label className="block text-xs mb-1">
                                        Instructions for medication
                                    </label>
                                    <Textarea
                                        value={formData.instructions}
                                        onChange={(e) =>
                                            setFormData((f) => ({
                                                ...f,
                                                instructions: e.target.value,
                                            }))
                                        }
                                        placeholder="Provide instructions for the patient"
                                    />
                                </div>
                            </div>
                        ),
                        validate: (formData) =>
                            !!formData.dosage &&
                            !!formData.price &&
                            !!formData.duration &&
                            !durationError &&
                            !!formData.instructions,
                    }
                ]}
                onComplete={async (formData) => {
                    const num = Number(formData.duration);
                    const formattedDuration = !isNaN(num) && formData.duration.trim() !== ''
                        ? `${num} ${num === 1 ? 'day' : 'days'}`
                        : formData.duration;
                    try {
                        await handleSubmit({
                            medication: formData.newMedication,
                            dosage: formData.dosage,
                            duration: formattedDuration,
                            cost: Number(formData.price) || 0,
                            note: formData.instructions,
                            reason: formData.reason,
                            refills: Number(formData.refills) || 0,
                            vitamin: {
                                name: formData.vitamin
                            }, // pass vitamin
                            substitute: true,
                            patient_id: userId ?? ""
                        });
                        setMedication(formData.newMedication);
                        setVitamin(formData.vitamin); // set vitamin
                        setMedicationReviewed(true);
                        setOpenReviewModal(false);
                    } catch (error) {
                        // Error is already handled by the hook (toast shown)
                    }
                }}
            />

            {/* ✅ Delete Medication Modal */}
            <AlertDialog open={openDeleteDialog} onOpenChange={setOpenDeleteDialog}>
                <AlertDialogContent>
                    <AlertDialogCancel asChild>
                        <Button
                            variant="ghost"
                            className="absolute right-4 top-4 h-6 w-6 p-0"
                        >
                            <X className="h-4 w-4" />
                            <span className="sr-only">Close</span>
                        </Button>
                    </AlertDialogCancel>
                    <div className="mt-10 text-center w-full flex items-center border-b">
                        <p className="w-full mx-auto text-[#2D2F35] font-medium text-[20px] md:w-[70%]">
                            Are you sure you want to delete this medication? This action
                            cannot be undone.
                        </p>
                    </div>
                    <AlertDialogFooter>
                        <AlertDialogCancel asChild>
                            <Button className="rounded-[10px] h-[46px]" variant="outline">
                                Cancel
                            </Button>
                        </AlertDialogCancel>
                        <AlertDialogAction asChild>
                            <Button
                                className="rounded-[10px] h-[46px]"
                                disabled={medicationReviewed}
                                onClick={() => {
                                    setMedicationReviewed(false);
                                    setNewMedication("");
                                    setJustification("");
                                    setDosage("");
                                    setPrice("");
                                    setDuration("");
                                    setRefills("");
                                    setInstructions("");
                                    setVitamin(""); // reset vitamin
                                    setOpenDeleteDialog(false);
                                }}
                            >
                                Confirm
                            </Button>
                        </AlertDialogAction>
                    </AlertDialogFooter>
                </AlertDialogContent>
            </AlertDialog>
        </div>
    );
};

export default UrgentCareMedication;
